/* Luvora PRO · motor de las paginas de producto (galeria, animaciones, resenas, FAQ, popup) */
(function(){
  "use strict";
  var C = window.LV_CFG || {};
  var root = document.querySelector(".acne-root");
  if (!root) return;
  root.classList.add("az-js");
  window.LV_READY = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var IO = "IntersectionObserver" in window;
  function $(id){ return document.getElementById(id); }
  function pad(n){ return n < 10 ? "0" + n : "" + n; }
  function pick(a){ return a[Math.floor(Math.random() * a.length)]; }
  function each(l, f){ Array.prototype.forEach.call(l, f); }
  function onView(el, f, th){ if (!el) return; if (!IO || reduce) { f(); return; } var o = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { o.disconnect(); f(); } }, { threshold: th || .4 }); o.observe(el); }

  each(document.querySelectorAll("[data-jump]"), function(a){ if (!document.querySelector(a.getAttribute("href"))) a.hidden = true; });

  var WA = C.wa || "593963190407";
  var PROD = C.pname || "Luvora";
  function waLink(m){ return "https://wa.me/" + WA + "?text=" + encodeURIComponent(m); }
  each(document.querySelectorAll("[data-wa]"), function(a){ a.href = waLink(a.getAttribute("data-wa") || ("Hola! Quiero info sobre " + PROD + " de Luvora.")); });

  /* Galeria: pasa sola cada 3,5 s, se desliza con el dedo, visor al tocar */
  (function(){
    var main = $("azGalMain"), th = $("azGalThumbs"); if (!main) return;
    var list = (C.gallery || []).filter(function(u){ return u && u.length; }), n = list.length;
    if (!n) return;
    var DUR = 3500, cur = 0, timer, moved = false;
    var imgs = list.map(function(u, i){ var im = document.createElement("img"); im.src = u; im.alt = PROD + " foto " + (i + 1); if (i) im.loading = "lazy"; else im.className = "on"; main.appendChild(im); return im; });
    var prog = document.createElement("div"); prog.className = "az-gal-prog"; prog.style.setProperty("--dur", DUR + "ms");
    if (n > 1) { list.forEach(function(){ prog.appendChild(document.createElement("i")); }); main.appendChild(prog); }
    var tb = [];
    if (th) list.forEach(function(u, i){ var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Ver foto " + (i + 1)); b.innerHTML = '<img src="' + u + '" alt="" loading="lazy">'; b.addEventListener("click", function(){ show(i); play(); }); th.appendChild(b); tb.push(b); });
    function show(i){
      i = (i + n) % n; imgs[cur].classList.remove("on"); cur = i; imgs[cur].classList.add("on");
      tb.forEach(function(b, k){ b.classList.toggle("on", k === cur); });
      each(prog.children, function(d, k){ d.classList.remove("on"); d.classList.toggle("done", k < cur); });
      var a = prog.children[cur]; if (a) { void a.offsetWidth; a.classList.add("on"); }
    }
    function play(){ clearInterval(timer); if (reduce || n < 2) return; timer = setInterval(function(){ if (document.visibilityState === "visible") show(cur + 1); }, DUR); }
    var x0 = 0;
    main.addEventListener("touchstart", function(e){ x0 = e.touches[0].clientX; moved = false; }, { passive: true });
    main.addEventListener("touchend", function(e){ var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { moved = true; show(cur + (dx < 0 ? 1 : -1)); play(); } }, { passive: true });
    var lb = $("azLb");
    main.addEventListener("click", function(){ if (moved || !lb) return; $("azLbInner").innerHTML = '<img src="' + list[cur] + '" alt="">'; lb.classList.add("open"); clearInterval(timer); });
    if (lb) lb.addEventListener("click", function(){ lb.classList.remove("open"); play(); });
    show(0); play();
  })();

  /* Resenas */
  (function(){
    var RS = C.rsum || { avg: 4.8, count: 174, dist: [86, 10, 3, 1, 0] };
    var el = $("azRsum");
    if (el) {
      var bars = RS.dist.map(function(p, i){ return '<div class="az-rbar"><span>' + (5 - i) + '★</span><span class="t"><span class="f" data-w="' + (p / 100) + '"></span></span><span>' + p + '%</span></div>'; }).join("");
      el.innerHTML = '<div class="az-rscore"><div class="num">' + RS.avg.toFixed(1) + '</div><span class="az-stars">★★★★★</span><div class="c">' + RS.count + ' reseñas</div></div><div class="az-rbars">' + bars + '</div>';
      onView(el, function(){ each(el.querySelectorAll(".f"), function(f){ f.style.setProperty("--w", f.getAttribute("data-w")); }); });
    }
    var photos = (C.revPhotos || []).filter(function(u){ return u && u.length; }), pi = 0;
    var rp = $("azRevPics");
    if (rp && photos.length) rp.innerHTML = '<p class="az-revpics-l">📸 Fotos de nuestros clientes</p><div class="az-revpics">' + photos.map(function(u){ return '<figure><img src="' + u + '" alt="Foto de cliente"><figcaption>✔ Cliente</figcaption></figure>'; }).join("") + '</div>';
    var g = $("azReviews"), reviews = C.reviews || []; if (!g || !reviews.length) return;
    function stars(r){ return "★★★★★".slice(0, r) + (r < 5 ? '<span style="opacity:.25">' + "★★★★★".slice(0, 5 - r) + '</span>' : ""); }
    var html = reviews.map(function(r){
      var photo = "";
      if (r.photo && photos[pi]) { photo = '<div class="az-rev-photo"><img src="' + photos[pi] + '" alt="Foto de ' + r.name + '"></div>'; pi++; }
      return '<div class="az-rev"><div class="az-rev-top"><span class="az-stars">' + stars(r.rating) + '</span><span class="date">' + r.date + '</span></div>' + photo + '<p>“' + r.text + '”</p><div class="az-rev-who"><div class="az-av">' + r.name.charAt(0) + '</div><div><div class="az-rev-name">' + r.name + ' <span class="az-vf">✔ Verificada</span></div><div class="az-rev-loc">' + r.loc + ', Ecuador</div></div></div></div>';
    }).join("");
    g.innerHTML = html + html;
    if (reduce) return;
    var paused = false, acc = 0;
    g.addEventListener("mouseenter", function(){ paused = true; });
    g.addEventListener("mouseleave", function(){ paused = false; });
    g.addEventListener("touchstart", function(){ paused = true; }, { passive: true });
    g.addEventListener("touchend", function(){ setTimeout(function(){ paused = false; }, 2500); });
    (function loop(){ if (!paused && g.scrollWidth > g.clientWidth) { acc += 0.45; var m = Math.floor(acc); if (m >= 1) { acc -= m; var half = g.scrollWidth / 2, nx = g.scrollLeft + m; if (nx >= half) nx -= half; g.scrollLeft = nx; } } requestAnimationFrame(loop); })();
  })();

  /* FAQ */
  (function(){
    var l = $("azFaq"), faq = C.faq || []; if (!l) return;
    faq.forEach(function(it, i){
      var w = document.createElement("div"); w.className = "az-faq-i" + (i === 0 ? " open" : "");
      w.innerHTML = '<button type="button" class="az-faq-q" aria-expanded="' + (i === 0) + '"><span>' + it.q + '</span><span class="az-faq-p" aria-hidden="true">+</span></button><div class="az-faq-a"><div><p>' + it.a + '</p></div></div>';
      var q = w.querySelector(".az-faq-q");
      q.addEventListener("click", function(){ var o = w.classList.contains("open"); each(l.children, function(x){ x.classList.remove("open"); x.querySelector(".az-faq-q").setAttribute("aria-expanded", "false"); }); if (!o) { w.classList.add("open"); q.setAttribute("aria-expanded", "true"); } });
      l.appendChild(w);
    });
  })();

  /* Contadores */
  function animNum(el){ var target = parseFloat(el.getAttribute("data-count")), suf = el.getAttribute("data-suffix") || "", s = null;
    if (reduce) { el.textContent = target + suf; return; }
    (function step(ts){ if (!s) s = ts; var p = Math.min((ts - s) / 1300, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(e * target) + suf; if (p < 1) requestAnimationFrame(step); })(performance.now()); }
  if (IO) { var oc = new IntersectionObserver(function(en){ en.forEach(function(e){ if (e.isIntersecting) { animNum(e.target); oc.unobserve(e.target); } }); }, { threshold: .6 });
    each(document.querySelectorAll("[data-count]"), function(el){ oc.observe(el); }); }

  /* Cuenta regresiva + urgencia + personas viendo */
  (function(){
    var el = $("azCount");
    if (el) { var KEY = "lvDeadline", t = 0; try { t = Number(localStorage.getItem(KEY)) || 0; } catch(e){}
      var nt = function(){ var x = Date.now() + (4 * 3600 + 59 * 60 + 59) * 1000; try { localStorage.setItem(KEY, x); } catch(e){} return x; };
      if (t < Date.now()) t = nt();
      (function tick(){ var d = t - Date.now(); if (d <= 0) { t = nt(); d = t - Date.now(); } var s = Math.floor(d / 1000); el.textContent = pad(Math.floor(s / 3600)) + ":" + pad(Math.floor((s % 3600) / 60)) + ":" + pad(s % 60); setTimeout(tick, 1000); })(); }
    var ut = $("azUrgTime"), uf = $("azUrgFill");
    if (ut && uf) { var total = 300, left = 300; (function tick(){ ut.textContent = pad(Math.floor(left / 60)) + ":" + pad(left % 60); uf.style.transform = "scaleX(" + (left / total) + ")"; left--; if (left < 0) left = total; setTimeout(tick, 1000); })(); }
    var v = $("azViewers"); if (v) setInterval(function(){ v.textContent = 31 + Math.floor(Math.random() * 28); }, 4500);
    var y = $("azYear"); if (y) y.textContent = new Date().getFullYear();
  })();

  /* Aparicion al hacer scroll (con escalonado) */
  each(document.querySelectorAll(".az-stagger"), function(p){ each(p.children, function(c, i){ c.style.setProperty("--i", i); }); });
  var revealEls = document.querySelectorAll(".az-reveal, .az-pop-in, .az-stagger > *");
  if (IO && !reduce) { var or = new IntersectionObserver(function(en){ en.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add("in-view"); or.unobserve(e.target); } }); }, { threshold: .12, rootMargin: "0px 0px -40px 0px" });
    each(revealEls, function(el){ or.observe(el); }); }
  else { each(revealEls, function(el){ el.classList.add("in-view"); }); }

  /* Carrusel de ingredientes: flechas, puntos y avance automatico */
  (function(){
    var mq = $("azIngMq"), dots = $("azIngDots"); if (!mq) return;
    var cards = mq.querySelectorAll(".az-ing2"), n = cards.length, idle = true, t;
    function step(){ return cards[0] ? cards[0].getBoundingClientRect().width + 16 : 248; }
    if (dots) { for (var i = 0; i < n; i++) dots.appendChild(document.createElement("i")); }
    function paint(){ if (!dots) return; var c = Math.round(mq.scrollLeft / step()); each(dots.children, function(d, i){ d.classList.toggle("on", i === c); }); }
    function go(d){ var max = mq.scrollWidth - mq.clientWidth, nx = mq.scrollLeft + d * step(); if (nx > max + 4) nx = 0; if (nx < -4) nx = max; mq.scrollTo({ left: nx, behavior: reduce ? "auto" : "smooth" }); }
    function hold(){ idle = false; clearTimeout(t); t = setTimeout(function(){ idle = true; }, 6000); }
    window.azIngGo = function(d){ hold(); go(d); };
    mq.addEventListener("scroll", function(){ requestAnimationFrame(paint); }, { passive: true });
    mq.addEventListener("touchstart", hold, { passive: true });
    paint();
    if (!reduce) setInterval(function(){ if (idle && document.visibilityState === "visible") go(1); }, 3200);
  })();

  /* Antes / despues: deslizador con demostracion */
  (function(){
    var b = $("azBas"); if (!b) return; var r = b.querySelector("input");
    function set(v){ b.style.setProperty("--pos", v + "%"); }
    r.addEventListener("input", function(){ set(r.value); });
    set(r.value);
    onView(b, function(){ if (reduce) return; var v = 50, dir = -1, k = 0;
      (function wig(){ v += dir * 1.1; if (v < 22) dir = 1; if (v > 78) dir = -1; if (v > 49 && v < 51 && k > 80) { set(50); r.value = 50; return; } k++; set(v); r.value = v; requestAnimationFrame(wig); })(); }, .5);
  })();

  /* Tabla comparativa: si no entra, avisa y muestra que se desliza */
  (function(){
    var w = document.querySelector(".az-cmp-wrap"); if (!w) return;
    function chk(){ w.classList.toggle("can-scroll", w.scrollWidth > w.clientWidth + 4); }
    chk(); window.addEventListener("resize", chk);
    onView(w, function(){ if (reduce || !w.classList.contains("can-scroll")) return; w.scrollTo({ left: 140, behavior: "smooth" }); setTimeout(function(){ w.scrollTo({ left: 0, behavior: "smooth" }); }, 1100); }, .5);
    w.addEventListener("scroll", function(){ if (w.scrollLeft > 20) w.classList.add("seen"); }, { passive: true });
  })();

  /* Popup de compra (2 o 3 unidades) */
  (function(){
    var pop = $("azPop"); if (!pop) return;
    var main = $("azPopMain"), sub = $("azPopSub");
    var names = ["Andrea de Guayaquil","Doménica de Quito","Carla de Cuenca","Valeria de Manta","Gabriela de Ambato","María José de Machala","Anahí de Riobamba","Paula de Ibarra","Camila de Loja","Salomé de Portoviejo","Nicole de Esmeraldas","Daniela de Santo Domingo","Fernanda de Latacunga","Karen de Babahoyo"];
    var acts = C.popActs || ["pidió 2 unidades","pidió 3 unidades"];
    var times = ["hace 2 min","hace 4 min","hace 7 min","hace 3 min","hace 9 min","hace 12 min"];
    function show(){ main.textContent = pick(names) + " " + pick(acts); sub.textContent = pick(times) + " · pago contra entrega"; pop.classList.add("show"); setTimeout(function(){ pop.classList.remove("show"); }, 5200); }
    setTimeout(function(){ show(); setInterval(show, 19000); }, 7000);
  })();
})();